import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { MathJaxContext } from "better-react-mathjax";
import { mathJaxConfig } from "./mathjaxConfig.ts";
import { environment } from "@environments/environment.ts";

if (environment.production) {
  console.log = () => {};
  console.warn = () => {};
  console.error = () => {};
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <MathJaxContext config={mathJaxConfig}>
      <App />
    </MathJaxContext>
  </StrictMode>
);
